import React from "react";

const PaymentConfirmationVertical = (props) => {
  const {
    isPaymentPartiallyComplete,
    isTipPartiallyPaid,
    isPaymentComplete,
    isPartiallyPaid,
    isPaymentFailed,
    seat,
    giftCardTicket,
    serverAppTheme,
    paymentConfirmation,
    sliceTicketData,
    creditCardData,
    partialTipData,
    styles,
    paymentStatus,
    setShowTicketDetails,
    paymentProcess,
    showCheckSeat,
    LABEL,
    cn,
    SUCCESS,
    PENDING,
    ERROR,
    QUESTION,
    TouchableButton,
    SearchIcon,
  } = props;

  return (
    <div className="h-100 w-100">
      <div
        className={cn(
          "d-flex justify-content-center align-items-center font-weight-bold h-40",
        )}
      >
        {isPaymentPartiallyComplete && (
          <div className="h-100 w-100">
            <div
              className="fs_32 pt-12 pb-2 fw-500 text-center"
              style={{ fontSize: "1.8rem" }}
            >
              {isPaymentPartiallyComplete &&
                LABEL().PPES_PAYMENT_PARTIALLY_APPROVED}
            </div>
            <div
              className="w-100 p-12 fs_20 fw-600 rounded"
              style={{ backgroundColor: serverAppTheme?.checkDetail_tabs }}
            >
              {seat.paymentCheck?.giftCardTicketId && (
                <div className="col-12 px-0 d-flex">
                  <div className="col-9 pl-0 pr-1 text-left">
                    {seat.paymentCheck?.giftCardTicketId && (
                      <>
                        {" "}
                        Gift card{" "}
                        {
                          seat?.paymentCheck?.tickets?.filter(
                            (el) =>
                              el.id === seat?.paymentCheck?.giftCardTicketId,
                          )[0]?.redactedCardNumber
                        }
                      </>
                    )}
                  </div>
                  <div className="col-3 pl-1 pr-0 text-right">
                    {seat.paymentCheck?.giftCardTicketId && (
                      <>
                        {LABEL().CURRENCY_SYMBOL +
                          giftCardTicket[0]?.ticketAmount?.toFixed(2)}
                      </>
                    )}
                  </div>
                </div>
              )}
              {creditCardData?.map(({ type, amount }) =>
                paymentStatus({ type, amount }),
              )}
            </div>
          </div>
        )}
        {isTipPartiallyPaid && (
          <div className="h-100 w-100">
            <div className="fs_32 pt-12 pb-2 fw-500 text-center">
              {isTipPartiallyPaid && LABEL().PPES_PAYMENT_PARTIALLY_APPROVED}
            </div>
            <div
              className="w-100 p-12 fs_20 fw-600 rounded"
              style={{ backgroundColor: serverAppTheme?.checkDetail_tabs }}
            >
              {partialTipData?.map(({ type, amount }) =>
                paymentStatus({ type, amount }),
              )}
            </div>
          </div>
        )}
        {(isPaymentComplete || isPartiallyPaid) && (
          <div className="h-100 w-100">
            <div className="fs_32 pt-12 pb-2 fw-500 text-center">
              {isPartiallyPaid
                ? LABEL().PC_PAYMENT_SUCCESSFUL
                : LABEL().PC_PAYMENT_COMPLETE}
            </div>
            <div
              className="w-100 p-12 fs_20 fw-600 rounded"
              style={{ backgroundColor: serverAppTheme?.checkDetail_tabs }}
            >
              {sliceTicketData?.map((item) => (
                <>
                  {item.paymentTypeName === "Cash" ? (
                    <>
                      <div className="col-12 px-0 d-flex">
                        <div className="col-9 pl-0 pr-1 text-left">
                          {item?.paymentTypeName}
                        </div>
                        <div className="col-3 pl-1 pr-0 text-right">
                          {LABEL().CURRENCY_SYMBOL}
                          {item?.ticketAmount?.toFixed(2)}
                        </div>
                      </div>
                      <div className="col-12 px-0 d-flex fs_16 fw-400">
                        <div className="col-6 px-0 text-left">
                          <span>{LABEL().EPS_COLLECTED}:</span>
                          <span className="px-1">
                            {LABEL().CURRENCY_SYMBOL}
                            {item?.cashCollectedAmount?.toFixed(2)}
                          </span>
                        </div>
                        <div className="col-6 px-0 text-right">
                          <span>{LABEL().EPS_CHANGE}:</span>
                          <span className="px-1">
                            {LABEL().CURRENCY_SYMBOL}
                            {item?.cashChangeAmount?.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-12 px-0 d-flex">
                        <div className="col-9 pl-0 pr-1 text-left">
                          {item?.paymentTypeName}{" "}
                          {item?.paymentTypeName === "Gift Card"
                            ? item?.redactedCardNumber
                            : `${item?.cardType}-${item?.redactedCardNumber?.substr(item?.redactedCardNumber?.length - 4)}`}
                        </div>
                        <div className="col-3 pl-1 pr-0 text-right">
                          {LABEL().CURRENCY_SYMBOL}
                          {item?.ticketAmount?.toFixed(2)}
                        </div>
                      </div>
                      {item?.paymentTypeName === "Gift Card" && (
                        <div className="col-12 px-0 d-flex fs_16 fw-400">
                          <div className="col-9 pl-0 pr-1 text-left">
                            {LABEL().RS_BALANCE_AMOUNT}
                          </div>
                          <div className="col-3 pl-1 pr-0 text-right">
                            {LABEL().CURRENCY_SYMBOL}
                            {item?.balanceAmount?.toFixed(2) || 0.0}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              ))}
              {seat?.paymentCheck?.tickets?.length > 1 && (
                <div className="col-12 px-0 pt-2 d-flex fs_24">
                  <div className="col-6 pl-0 pr-1">{LABEL().RECEIPT_TOTAL}</div>
                  <div className="col-6 pl-1 pr-0 text-right">
                    {LABEL().CURRENCY_SYMBOL}
                    {seat?.paymentCheck?.tickets
                      ?.reduce((acc, currVal) => acc + currVal?.ticketAmount, 0)
                      ?.toFixed(2)}
                  </div>
                </div>
              )}
            </div>

            <div className="col-12 px-0 text-right">
              {seat?.paymentCheck?.tickets?.length > 3 && (
                <>
                  <SearchIcon stroke={serverAppTheme?.iconcolor} />
                  <span
                    className="px-2 fs_12 fw-500 text-underline text-capitalize"
                    tabIndex="0"
                    role="button"
                    onClick={() => setShowTicketDetails(true)}
                  >
                    {LABEL().PC_DETAILS}
                  </span>
                </>
              )}
            </div>
          </div>
        )}
        {isPaymentFailed && (
          <div className="fs_32 pt-12 pb-2 fw-500 text-center">
            {paymentConfirmation.errorMsg}
          </div>
        )}
      </div>
      <div
        className={cn(
          "d-flex justify-content-center align-items-center text-center", !isPartiallyPaid ? 'h-35' : 'h-26',
        )}
      >
        <div style={{ width: "250px" }}>
          {isPaymentComplete || isPartiallyPaid ? (
            <img src={SUCCESS} className="w-100" alt="SUCCESS" />
          ) : isPaymentPartiallyComplete ? (
            <img src={PENDING} className="w-100" alt="PENDING" />
          ) : isPaymentFailed ? (
            <img src={ERROR} className="w-100" alt="ERROR" />
          ) : (
            isTipPartiallyPaid && (
              <img src={QUESTION} className="w-100" alt="QUESTION" />
            )
          )}
        </div>
      </div>
      <div className={cn("col-12 px-0", showCheckSeat() ? 'h-13 mb-1' : 'h-15')}>
        {seat?.paymentCheck?.paymentAmount > 0 && !isPaymentFailed && (
          <>
            <div
              className={cn(
                "px-0 h-35 d-flex justify-content-center fs_32 fw-500 py- 1 col-12",
              )}
            >
              {isTipPartiallyPaid
                ? LABEL().PPES_UNCOLLECTED_TIP
                : LABEL().PC_DUE}
            </div>
            <div
              className={cn(
                "px-0  d-flex justify-content-center fw-600 py-1 fs_48 col-12 h-65",
              )}
              style={{ fontWeight: 300 }}
            >
              {LABEL().CURRENCY_SYMBOL}
              {isTipPartiallyPaid
                ? seat?.control?.partialTipBalanceAmount?.toFixed(2)
                : seat?.paymentCheck?.paymentAmount?.toFixed(2)}
            </div>
          </>
        )}
      </div>
      <div className={cn("d-flex align-items-end justify-content-center", showCheckSeat() ? styles.btnAlignmnt : styles.btnAlignmnt2, !isPartiallyPaid ? 'h-15' : '')}>
        <TouchableButton
          type="button"
          className={cn(
            "col-12 p-0 fs_28 fw-600 border-0 rounded btn-ripple text-white od-primary-btn-bg-color od-primary-btn-font-color",
            styles.btn68,
          )}
          style={{
            backgroundColor: serverAppTheme?.secondaryBtn,
          }}
          onClick={(event) => {
            event.preventDefault();
            paymentProcess();
          }}
          rippleEffect={true}
        >
          {(isPaymentComplete || isPartiallyPaid || isTipPartiallyPaid) && (
            <div>{LABEL().PC_CONTINUE}</div>
          )}
          {isPaymentPartiallyComplete && (
            <>
              {LABEL().PPES_PAY_BALANCE} {LABEL().CURRENCY_SYMBOL}
              {seat?.paymentCheck?.paymentAmount?.toFixed(2)}
            </>
          )}
          {isPaymentFailed && <div>{LABEL().PPES_RETRY}</div>}
        </TouchableButton>
      </div>
    </div>
  );
};

export default PaymentConfirmationVertical;
